export default __webpack_public_path__ + "static/media/rightArrow_icon.695044a3.svg";